import Types from './Types';



// ################# Action Creators ########################

// Auth and User Actions

const loginUser = (payload, persistent, isGuest) => ({
    type: Types.LOGIN_USER,
    payload,
    persistent,
    isGuest
});

const loginResponse = (response) => ({
    type: Types.LOGIN_RESPONSE,
    response
});

const setHSGBannerFlag = (flag) => ({
    type: Types.SET_HSG_BANNER_FLAG,
    flag
})

const loginUsingMagicLink = (magicLink, studentId, meta) => ({
    type: Types.LOGIN_USING_MAGIC_LINK,
    magicLink,
    studentId,
    meta
})

const loginResponseMagicLink = (magicLink) => ({
    type: Types.LOGIN_RESPONSE_MAGIC_LINK,
    magicLink
})

const loginUsingInvitationLink = (invitationLink, cookies) => ({
    type: Types.LOGIN_USING_INVITATION_LINK,
    invitationLink, cookies
})

const loginResponseInvitationLink = (result) => ({
    type: Types.LOGIN_RESPONSE_INVITATION_LINK,
    result
})

const changeMagicLinkStatus = (status) => ({
    type: Types.CHANGE_MAGIC_LINK_STATUS,
    status
})

const logoutUser = () => ({
    type: Types.LOGOUT_USER
});

const initializeForm = (formData) => ({
    type: Types.INITIALIZE_FORM,
    formData
});

const signupUser = (payload) => ({
    type: Types.SIGNUP_USER,
    payload
});

const signupUserV2 = (payload, otpInfo) => ({
    type: Types.SIGNUP_USER_V2,
    payload, otpInfo
}) 

const signupUserV2_1 = (payload) => ({
    type: Types.SIGNUP_USER_V2_1,
    payload
}) 

const signupResponse = (response) => ({
    type: Types.SIGNUP_RESPONSE,
    response
});

const updateUser = (payload, next) => ({
    type: Types.UPDATE_USER,
    payload,
    next
});

const responseUpdateUser = (response) => ({
    type: Types.RESPONSE_UPDATE_USER,
    response
});

const responseUpdateChildUser = (response) => ({
    type: Types.RESPONSE_UPDATE_CHILD_USER,
    response
});

const getUser = () => ({
    type: Types.GET_USER
});

const verifyAvailabilityEmail = (email) => ({
    type: Types.VERIFY_AVAILABILITY_EMAIL,
    email
});

const responseAvailabilityEmail = (response) => ({
    type: Types.RESPONSE_AVAILABILITY_EMAIL,
    response
});

const verifyAvailabilityPhone = (phone) => ({
    type: Types.VERIFY_AVAILABILITY_PHONE,
    phone
});

const responseAvailabilityPhone = (response) => ({
    type: Types.RESPONSE_AVAILABILITY_PHONE,
    response
});

const resetAvailabilityCode = () => ({
    type: Types.RESET_AVAILABILITY_CODE
});

const verifyAvailabilityCode = (code, dob) => ({
    type: Types.VERIFY_AVAILABILITY_CODE,
    code,
    dob
});

const responseAvailabilityCode = (response) => ({
    type: Types.RESPONSE_AVAILABILITY_CODE,
    response
});


// Dashboard Actions

const fetchChildList = (params) => ({
    type: Types.FETCH_CHILD_LIST,
    params
})

const responseChildList = (response) => ({
    type: Types.RESPONSE_CHILD_LIST,
    response
});

const addChildUsingActivationCode = (params) => ({
    type: Types.ADD_CHILD_USING_ACTIVATION_CODE,
    params
});

const responseAddChildUsingActivationCode = (response) => ({
    type: Types.RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE,
    response
});

const selectChild = (index) => ({
    type: Types.SELECT_CHILD,
    index
});

const fetchStudentAssessmentStatus = (userId, eventTrackId) => ({
    type: Types.FETCH_STUDENT_ASSESSMENT_STATUS,
    userId,
    eventTrackId
});

const responseStudentAssessmentStatus = (response) => ({
    type: Types.RESPONSE_STUDENT_ASSESSMENT_STATUS,
    response
});

const fetchPentahoReport = (reportName, studentId, startNodeId) => ({
    type: Types.FETCH_PENTAHO_REPORT,
    reportName,
    studentId,
    startNodeId
});

const responsePentahoReport = (response) => ({
    type: Types.RESPONSE_PENTAHO_REPORT,
    response
});

const downloadPentahoReport = (reportName, studentId, startNodeId) => ({
    type: Types.DOWNLOAD_PENTAHO_REPORT,
    reportName,
    studentId,
    startNodeId
});

const getDMFTIndex = (studentId, startNodeId) => ({
    type: Types.GET_DMFT_INDEX,
    studentId,
    startNodeId
})

const updateDMFTIndex = (dmftIndex) => ({
    type: Types.UPDATE_DMFT_INDEX ,
    dmftIndex
})


const resetExpertQueries = () => ({
    type: Types.RESET_EXPERT_QUERIES
});

const postExpertQueries = (params) => ({
    type: Types.POST_EXPERT_QUERIES,
    params
});

const responseExpertQueries = (response) => ({
    type: Types.RESPONSE_EXPERT_QUERIES,
    response
});


// Dialog Request Appointment Actions

const resetAppointmentRequest = () => ({
    type: Types.RESET_APPOINTMENT_REQUEST
});

const draDropdownSelect = (id, index) => ({
    type: Types.DRA_SELECT_COUNTRY,
    id,
    index
});

const draChangeRequest = (request) => ({
    type: Types.DRA_CHANGE_REQUEST,
    request
});

const postAppointmentRequest = (params) => ({
    type: Types.POST_APPOINTMENT_REQUEST,
    params
});

const responseAppointmentRequest = (response) => ({
    type: Types.RESPONSE_APPOINTMENT_REQUEST,
    response
});


// Metadata Actions

const fetchCountryList = () => ({
    type: Types.FETCH_COUNTRIES
});

const responseCountryList = (response) => ({
    type: Types.RESPONSE_COUNTRIES,
    response
});

const fetchStateList = (countryId) => ({
    type: Types.FETCH_STATES,
    countryId
});

const responseStateList = (response) => ({
    type: Types.RESPONSE_STATES,
    response
});

const fetchCityList = (stateId) => ({
    type: Types.FETCH_CITIES,
    stateId
});

const responseCityList = (response) => ({
    type: Types.RESPONSE_CITIES,
    response
});

const fetchPartnerList = () => ({
    type: Types.FETCH_PARTNERS
});

const responsePartnerList = (response) => ({
    type: Types.RESPONSE_PARTNERS,
    response
});

const fetchSpecialityList = () => ({
    type: Types.FETCH_SPECIALITIES
});

const responseSpecialityList = (response) => ({
    type: Types.RESPONSE_SPECIALITIES,
    response
});

const fetchOffersList = () => ({
    type: Types.FETCH_OFFERS
});

const responseOffersList = (response) => ({
    type: Types.RESPONSE_OFFERS,
    response
});

const fetchVaccination = () => ({
    type: Types.FETCH_VACCINATION
});

const responseVaccination = (response) => ({
    type: Types.RESPONSE_VACCINATION,
    response
});

const getGlossary = () => ({
    type: Types.GET_GLOSSARY
})

const storeGlossary = (payload, error) => ({
    type: Types.STORE_GLOSSARY,
    payload,
    error
})

const changePassword = (password, avoidLogout) => ({
    type: Types.CHANGE_PASSWORD,
    password, avoidLogout
})

// const updateParentInfo = (config, studentConfig) => ({
//     type: Types.UPDATE_PARENT_INFO,
//     config,
//     studentConfig
// })
 
const sendOtp = (phone, email, userId) => ({
    type: Types.SEND_OTP,
    phone, email, userId
})

const sendOtpPhone = (username, isRegistered) => ({
    type: Types.SEND_OTP_PHONE,
    username, isRegistered
})

const responseSendOtpPhone = (response) => ({
    type: Types.RESPONSE_SEND_OTP_PHONE,
    response
})

const verifyOtp = (username, otp) => ({
    type: Types.VERIFY_OTP,
    username,
    otp
})

const responseVerifyOtp = (response) => ({
    type: Types.RESPONSE_VERIFY_OTP,
    response
})

//Methods Are for Checking availabilty Of email,phone,activaitoncode without DOB
const checkEmailAvailability = (email) => ({
    type: Types.CHECK_EMAIL_AVAILABILITY,
    email
});

const responseCheckEmailAvailability = (response) => ({
    type: Types.RESPONSE_CHECK_EMAIL_AVAILABILITY,
    response
});

const checkPhoneNumberAvailability = (phone) => ({
    type: Types.CHECK_PHONE_NUMBER_AVAILABILITY,
    phone
});

const responseCheckPhoneNumberAvailability = (response) => ({
    type: Types.RESPONSE_CHECK_PHONE_NUMBER_AVAILABILITY,
    response
});

const checkActivationCodeAvailability = (code) => ({
    type: Types.CHECK_ACTIVATION_CODE_AVAILABILITY,
    code
});

const responseCheckActivationCodeAvailability = (response) => ({
    type: Types.RESPONSE_CHECK_ACTIVATION_CODE_AVAILABILITY,
    response
});

const changeValidationResponseType = (str) => ({
    type: Types.CHANGE_VALIDATION_RESPONSE_TYPE,
    str
});

const responseChangeValidationResponseType = (response) => ({
    type: Types.RESPONSE_CHANGE_VALIDATION_RESPONSE_TYPE,
    response
});
//Methods End HERE


const addChildUsingActivationCodeWithoutDOB = (params) => ({
    type: Types.ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB,
    params
});

const responseAddChildUsingActivationCodeWithoutDOB = (response) => ({
    type: Types.RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB,
    response
});

const resetActivationCode = (status) => ({
    type: Types.RESET_ACTIVATION_CODE,
    status
});

const responseResetActivationCode = (status) => ({
    type: Types.RESPONSE_RESET_ACTIVATION_CODE,
    status
});

const updateSelectedChildOnUpdate = (obj) => ({
    type: Types.UPDATE_SELECTED_CHILD_ON_UPDATE,
    obj
});

const fetchUserSignUpStatus = (phoneNumber) => ({
    type: Types.FETCH_USER_SIGNUP_STATUS,
    phoneNumber
})

const storeUserSignUpStatus = (response) => ({
    type: Types.STORE_USER_SIGNUP_STATUS,
    response
})

const sendMagicLink = (magicLink, email, phone) => ({
    type: Types.SEND_MAGIC_LINK,
    magicLink,
    email,
    phone
})

const responseMagicLink = (response) => ({
    type: Types.RESPONSE_MAGIC_LINK,
    response
})

const putUserAssociation = (params) => ({
    type: Types.PUT_USER_ASSOCIATION,
    params
})

// const responsePutUserAssociation = (response) => ({
//     type: Types.PUT_USER_ASSOCIATION,
//     response
// })

const hideStudentVerificationModal = () => ({
    type: Types.PUT_USER_ASSOCIATION,
})

const sendStudentVerificationEmail = (payload) => ({
    type: Types.SEND_STUDENT_VERIFICATION_EMAIL,
    payload
})

const parentUpdateResponse = (response) => ({
    type: Types.PARENT_UPDATE_RESPONSE,
    response
})

const handleVerifyUnRegisteredOtp = (username, otp, isUpdating) => ({
    type: Types.VERIFY_UNREGISTERED_OTP,
    username, otp, isUpdating
})

const postParentLinkedIn = (Secrets, code) => ({
    type: Types.POST_PARENT_LINKED_IN,
    Secrets, code
})

const updateParentInfo = (config) => ({
    type: Types.UPDATE_PARENT_INFO,
    config
})

const postCovidDeclarationForm = (studentId, organizationId, payload, file, roleType) => ({
    type: Types.POST_COVID_DECLARATION_FORM,
    studentId, organizationId, payload, file, roleType
})

const responseCovidDeclarationForm = (status) => ({
    type: Types.RESPONSE_COVID_DECLARATION_FORM,
    status
})

const getCovidDeclarationList = (params) => ({
    type: Types.GET_COVID_DECLARATION_LIST,
    params
})

const responseCovidDeclarationList = (results) => ({
    type: Types.RESPONSE_COVID_DECLARATION_LIST,
    results
})

const uploadDocuments = (fileObj, contentId, category, fileGroup, fileCustom, uuid) => ({
    type: Types.UPLOAD_DOCUMENTS,
    fileObj,
    contentId,
    category,
    fileGroup,
    fileCustom,
    uuid
})

const addContentID = (contentId, fileGroup, uuid) => ({
    type: Types.ADD_CONTENT_ID,
    contentId,
    fileGroup,
    uuid
})

const fetchDocuments = (contentId, fileGroup) => ({
    type: Types.FETCH_DOCUMENTS,
    contentId,
    fileGroup
})

const setLoader = (message) => ({
    type: Types.SET_LOADER,
    message
})

const unsetLoader = () => ({
    type: Types.UNSET_LOADER
})

const setSidebar = (state) => ({
    type: Types.SHOW_SIDEBAR,
    state
})

const unsetSidebar = (state) => ({
    type: Types.HIDE_SIDEBAR,
    state
})

const changeCurrentLocation = (location) => ({
    type: Types.CHANGE_CURRENT_LOCATION,
    location
})

const handleInvitationRequest = (payload, associations) => ({
    type: Types.HANDLE_INVITATION_REQUEST,
    payload, associations
})

const putInvitationRequestSuccess = (invitationLink) => ({
    type: Types.PUT_INVITATION_LINK_SUCCESS,
    invitationLink
})

const postInvitationRequest = (config) => ({
    type: Types.POST_INVITATION_LINK,
    config
})

const sendInvitationLinkViaPhone = (config) => ({
    type: Types.POST_INVITATION_LINK_VIA_PHONE,
    config
})

const getOrganization = (orgId) => ({
    type: Types.GET_ORGANIZATION,
    orgId,
});

const storeOrganization = (organization) => ({
    type: Types.STORE_ORGANIZATION,
    organization,
});

const getCovidGlobalDashboard = (stateName, cityName) => ({
    type: Types.GET_GLOBAL_COVID_DASHBOARD,
    stateName,
    cityName,
});

const responseCovidGlobalDashboard = (result) => ({
    type: Types.RESPONSE_GLOBAL_COVID_DASHBOARD,
    result,
});

const changeUserProfileModalState = (flag,modalType) => ({
    type: Types.CHANGE_USER_PROFILE_MODAL_STATE,
    modalType,
    flag
})

const updateUserProfile = (payload) => ({
    type: Types.UPDATE_USER_PROFILE,
    payload
})

const getCovidDeclarationOverallSymptomsV2 = (organizationId, startDate, endDate, userRole, metaFilters) => ({
    type: Types.GET_COVID_DECLARATION_OVERALL_SYMPTOMS_V2,
    organizationId,
    startDate,
    endDate,
    userRole, 
    metaFilters
});

const responseCovidDeclarationOverallSymptomsV2 = (result) => ({
    type: Types.RESPONSE_COVID_DECLARATION_OVERALL_SYMPTOMS_V2,
    result,
});

const getCovidGoogleRSSFeed = (limit, start) => ({
    type: Types.GET_COVID_GOOGLE_RSS_FEED,
    limit,
    start
});

const responseCovidGoogleRSSFeed = (result) => ({
    type: Types.RESPONSE_COVID_GOOGLE_RSS_FEED,
    result,
});

const getCovidGoogleRSSFeedImages = (rssFeed, index) => ({
    type: Types.GET_COVID_GOOGLE_RSS_FEED_IMAGES,
    rssFeed,
    index
});

const getCovidGoogleRSSFeedSingleImage = (index, link) => ({
    type: Types.GET_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE,
    index,
    link
});

const responseCovidGoogleRSSFeedSingleImage = (result) => ({
    type: Types.RESPONSE_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE,
    result,
});

const responseCovidGoogleRSSFeedImage = (result) => ({
    type: Types.RESPONSE_COVID_GOOGLE_RSS_FEED_IMAGE,
    result,
});

const sendEmail = (template, recipients, variables, subject) => ({
    type: Types.SEND_EMAIL,
    template, recipients, variables, subject
});

const makeCall = (numberTo, numberFrom) => ({
    type: Types.MAKE_CALL,
    numberTo,
    numberFrom
});

const getS3Access = () => ({
    type: Types.GET_S3_ACCESS
});

const responseS3Access = (response) => ({
    type: Types.RESPONSE_S3_ACCESS,
    response
});

const storeCovidData = (result) => ({
    type: Types.SET_COVID_DATA,
    result,
});

const changeUserLocation = (location) => ({
    type: Types.CHANGE__USER__LOCATION,
    location,
});

const resetLoginResponse = () => ({
    type: Types.RESET__LOGIN__RESPONSE
})

export default {

    getS3Access,
    responseS3Access,

    sendEmail,
    makeCall,

    responseCovidGoogleRSSFeedImage,
    getCovidGoogleRSSFeedImages,
    getCovidGoogleRSSFeedSingleImage,
    responseCovidGoogleRSSFeedSingleImage,

    getCovidGoogleRSSFeed,
    responseCovidGoogleRSSFeed,

    getCovidDeclarationOverallSymptomsV2,
    responseCovidDeclarationOverallSymptomsV2,

    updateUserProfile,
    
    changeUserProfileModalState,

    getCovidGlobalDashboard,
    responseCovidGlobalDashboard,

    sendInvitationLinkViaPhone,
    postInvitationRequest,

    putInvitationRequestSuccess,

    handleInvitationRequest,

    loginUsingInvitationLink,
    loginResponseInvitationLink,

    getOrganization,
    storeOrganization,

    changeCurrentLocation,
    
    responseCovidDeclarationList,
    getCovidDeclarationList,

    setLoader,
    unsetLoader,
    
    uploadDocuments,
    fetchDocuments,

    addContentID,

    postCovidDeclarationForm,
    responseCovidDeclarationForm,

    setHSGBannerFlag,
    
    postParentLinkedIn,
    handleVerifyUnRegisteredOtp,
    signupUserV2_1,
    signupUserV2,

    parentUpdateResponse,
    
    updateParentInfo,

    sendStudentVerificationEmail,

    hideStudentVerificationModal,

    putUserAssociation,

    responseMagicLink,
    sendMagicLink,
    
    fetchUserSignUpStatus,
    storeUserSignUpStatus,

    updateSelectedChildOnUpdate,
    
    changeMagicLinkStatus,

    loginUsingMagicLink,
    loginResponseMagicLink,

    resetActivationCode,
    responseResetActivationCode,

    addChildUsingActivationCodeWithoutDOB,
    responseAddChildUsingActivationCodeWithoutDOB,

    changeValidationResponseType,
    responseChangeValidationResponseType,
    
    checkEmailAvailability,
    checkPhoneNumberAvailability,
    checkActivationCodeAvailability,
    responseCheckEmailAvailability,
    responseCheckPhoneNumberAvailability,
    responseCheckActivationCodeAvailability,


    loginUser,
    loginResponse,
    logoutUser,
    sendOtp,

    sendOtpPhone,
    responseSendOtpPhone,

    verifyOtp,
    responseVerifyOtp,

    getGlossary,
    storeGlossary,
    changePassword,

    signupUser,
    signupResponse,

    updateUser,
    responseUpdateUser,
    responseUpdateChildUser,

    getUser,

    verifyAvailabilityEmail,
    responseAvailabilityEmail,
    verifyAvailabilityPhone,
    responseAvailabilityPhone,
    resetAvailabilityCode,
    verifyAvailabilityCode,
    responseAvailabilityCode,
    
    initializeForm,

    fetchChildList,
    responseChildList,

    addChildUsingActivationCode,
    responseAddChildUsingActivationCode,

    selectChild,

    fetchStudentAssessmentStatus,
    responseStudentAssessmentStatus,

    fetchPentahoReport,
    responsePentahoReport,

    downloadPentahoReport,

    getDMFTIndex,
    updateDMFTIndex,

    resetExpertQueries,
    postExpertQueries,
    responseExpertQueries,

    resetAppointmentRequest,
    draDropdownSelect,
    draChangeRequest,
    postAppointmentRequest,
    responseAppointmentRequest,

    fetchCountryList,
    responseCountryList,
    fetchStateList,
    responseStateList,
    fetchCityList,
    responseCityList,
    fetchPartnerList,
    responsePartnerList,
    fetchSpecialityList,
    responseSpecialityList,
    fetchOffersList,
    responseOffersList,

    fetchVaccination,
    responseVaccination,

    setSidebar,
    unsetSidebar,
    storeCovidData,

    changeUserLocation,
    resetLoginResponse
}